setInterval(() => {
    axios.get('/ping').then(response => {
        console.log('ping ' + response.status)
    })
}, 1000 * 60 * 60)
